module.exports = __webpack_public_path__ + "static/media/notification.4367b5f2.wav";